import React from "react";

import SocialShare from "../../../../../../components/SocialShare";
import { JobDetails } from "../utils/helpers";

interface JobHeaderProps {
	jobDetails: JobDetails;
	baseUrl: string;
	onBack: () => void;
	onShare: () => void;
}

export function JobHeader({ jobDetails, baseUrl, onBack, onShare }: JobHeaderProps) {
	return (
		<div className="flex items-start justify-between flex-wrap mb-8">
			<button className="text-primary-600 hover:text-primary-700 inline-block text-sm" onClick={onBack}>
				&larr; Back to Job Listings
			</button>
			<SocialShare
				message={`Check out this opportunity for a ${jobDetails?.jobTitle} at ${jobDetails?.company?.company_name || ""} ${baseUrl}companies/${jobDetails?.company?._id}`}
				link={`${baseUrl}jobs/${jobDetails?._id}`}
				onClick={onShare}
			/>
		</div>
	);
}
